import React from "react";
import { useTranslation } from "react-i18next";
import { FormBuilder } from "components/FormBuilder/FormBuilder";

const PAGE_LOCALE_KEY = "page.merchants.";
const FORM_LABEL_KEY = PAGE_LOCALE_KEY + "merchantDetail.info.others.fields";
const createOptions = (list, titleKey) =>
  (list ?? []).map((item) => ({
    key: item.id,
    value: item.id,
    title: item[titleKey],
  }));

const OthersSession = ({
  formProps,
  isEdit,
  isCreate,
  dropdownOptions,
  isLoading }) => {
  const { t } = useTranslation();

  const isDisabled = !isEdit || isLoading;

  const serviceIntegratorOptions = createOptions(
    dropdownOptions?.serviceIntegratorList,
    "company",
  );
  const referrerOptions = createOptions(
    dropdownOptions?.referrerList,
    "company",
  );
  const salesOptions = createOptions(dropdownOptions?.salesList, "firstName");

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    onboardSales: {
      fieldType: "selection",
      fieldName: "onboardSales",
      label: t(`${FORM_LABEL_KEY}.onboardSales`),
      disabled: true,
      config: {
        options: salesOptions,
      }
    },
    sales: {
      fieldType: "selection",
      fieldName: "sales",
      label: t(`${FORM_LABEL_KEY}.sales`),
      disabled: isDisabled,
      config: {
        options: salesOptions,
      }
    },
    referrer: {
      fieldType: "selection",
      fieldName: "referrer",
      label: t(`${FORM_LABEL_KEY}.referrer`),
      disabled: isDisabled,
      config: {
        options: referrerOptions,
      }
    },
    serviceIntegrator: {
      fieldType: "selection",
      fieldName: "serviceIntegrator",
      label: t(`${FORM_LABEL_KEY}.serviceIntegrator`),
      disabled: isDisabled,
      config: {
        options: serviceIntegratorOptions,
      }
    },
  }

  return (
    <FormBuilder.Section
      title={t(`${PAGE_LOCALE_KEY}merchantDetail.info.others.title`)}
      titleVariant="h3">
      <FormBuilder.Row itemsPerRow={2}>
        {
          FormBuilder.buildFields({
            formProps,
            fields: [
              !isCreate && fieldsConfig.onboardSales,
              fieldsConfig.sales,
              fieldsConfig.referrer,
              fieldsConfig.serviceIntegrator
            ]
          })
        }
      </FormBuilder.Row>
    </FormBuilder.Section>
  );
};
export default React.memo(OthersSession);
